import React from 'react';
import PropTypes from 'prop-types';
import fields from '../Field.constants';
import UpdateTextField from './UpdateTextField';
import UpdateSelectField from './UpdateSelectField';
import UpdateDateField from './UpdateDateField';
import UpdateAsyncSelectField from './UpdateAsyncSelectField';

function UpdateField({
    field,
    onChange,
    value: prevValue,
    year
}) {
    return (
        <>
            {(field === fields.TeamEmail) && (
                <UpdateTextField field={field} initialValue={prevValue} onChange={handleChange} />
            )}

            {field === fields.ReadyForApproval && (
                <UpdateSelectField field={field} initialValue={prevValue} onChange={handleChange} />
            )}

            {(field === fields.ContractEndDate || field === fields.ContractReleaseDate) && (
                <UpdateDateField field={field} initialValue={prevValue} onChange={handleChange} />
            )}

            {field === fields.Template && (
                <UpdateAsyncSelectField field={field} initialValue={prevValue} onChange={handleChange} year={year} />
            )}

            {(field === fields.MarkingMethod) && (
                <UpdateTextField field={field} initialValue={prevValue} onChange={handleChange} />
            )}

            {(field === fields.E_MarkingStartDate || field === fields.E_MarkingEndDate) && (
                <UpdateDateField field={field} initialValue={prevValue} onChange={handleChange} />
            )}
        </>
    );

    function handleChange(value) {
        if (value !== prevValue) {
            onChange(value);
        }
    }
}

UpdateField.propTypes = {
    field: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    year: PropTypes.string
};

export default UpdateField;
